import { action } from "satcheljs";
import type { ActionMessage } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import type { DetailPaneContent, DetailPaneMailLoadErrorDetails } from "owa-personal-os-types";
import { getMailLoadErrorDetails } from "./getMailLoadErrorDetails";

export interface OnDetailPaneOpenedActionMessage extends ActionMessage {
    content: DetailPaneContent;
    mailboxInfo: MailboxInfo;
    instanceId: number;
}

let nextDetailPaneInstanceId = 0;

export const onDetailPaneOpened: (content: DetailPaneContent, mailboxInfo: MailboxInfo) => OnDetailPaneOpenedActionMessage = action("onDetailPaneOpened", (content: DetailPaneContent, mailboxInfo: MailboxInfo) => ({
    content,
    mailboxInfo,
    instanceId: ++nextDetailPaneInstanceId,
}));

export const onDetailPaneClosed: () => ActionMessage = action("onDetailPaneClosed");

export interface OnDetailPaneMailLoadStartedActionMessage extends ActionMessage {
    contentId: string;
    loadId: number;
    instanceId: number;
}

let nextDetailPaneMailLoadId = 0;

export const onDetailPaneMailLoadStarted: (contentId: string, instanceId: number) => OnDetailPaneMailLoadStartedActionMessage = action("onDetailPaneMailLoadStarted", (contentId: string, instanceId: number) => ({
    contentId,
    instanceId,
    loadId: ++nextDetailPaneMailLoadId,
}));

export interface OnDetailPaneMailLoadFailedActionMessage extends ActionMessage {
    contentId: string;
    loadId: number;
    errorDetails: DetailPaneMailLoadErrorDetails;
}

export const onDetailPaneMailLoadFailed: (contentId: string, loadId: number, error: unknown) => OnDetailPaneMailLoadFailedActionMessage = action("onDetailPaneMailLoadFailed", (contentId: string, loadId: number, error: unknown) => ({
    contentId,
    loadId,
    errorDetails: getMailLoadErrorDetails(error),
}));
